import { render, staticRenderFns } from "./FormLanding.vue?vue&type=template&id=ca8ef2fe&scoped=true&"
import script from "./FormLanding.vue?vue&type=script&lang=js&"
export * from "./FormLanding.vue?vue&type=script&lang=js&"
import style0 from "./FormLanding.vue?vue&type=style&index=0&id=ca8ef2fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca8ef2fe",
  null
  
)

export default component.exports